module.exports = __webpack_public_path__ + "static/media/example-1080.f4839370.png";